import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useCallback } from "react";

export const companyAtom = atomWithStorage("company", {
  companyId: null,
});

const useCompanyStore = () => {
  const [company, setCompany] = useAtom(companyAtom);

  const setCompanyId = useCallback(
    (companyId) => {
      setCompany({
        companyId,
      });
    },
    [setCompany]
  );


  return {
    company,
    companyId: company?.companyId,
    setCompany,
    setCompanyId,
  };
};

export default useCompanyStore;